// Import: Middleware Action & Custom Types
import { CLEAN_NEIGHBORHOOD, CLEAN_NEIGHBORHOOD_ERROR } from '_models/redux/types';

// Action function
export const cleanNeighborhood = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_NEIGHBORHOOD,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_NEIGHBORHOOD_ERROR,
      payload: undefined,
    });
  }
};
